// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","title":"Footer_title__Q8g5X","button":"Footer_button__2oD+V"};